import { Component, Input, OnInit } from '@angular/core';
import { MultiLangPipe } from '../pipes/multi-lang.pipe';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent implements OnInit {

  @Input() data: any;

  @Input() config: {
    source?: any
    delay?: any
    jwtInclude?: boolean
    languageCode: string
    title: string
    url: string
    mapping?: {
      assetKey: string
    },
    redirectUrl?: string | any
  };

  constructor(
    private multiLangPipe: MultiLangPipe,) { }



  ngOnInit() {
    if (this.config) {
      if (this.config.hasOwnProperty('url') && this.config.url) {
        let url = this.multiLangPipe.transform(this.config.url).toString();
        if (url && url != '') {
          this.config.redirectUrl = url;
        }
      }
      this.redirectUrl();
    }
  }

  redirectUrl() {
    let delay = parseInt(this.config.delay, 10);
    let delayInMilliseconds = delay * 1000;
    try {
      setTimeout(() => {
        window.location.href = this.config.redirectUrl;
      }, delayInMilliseconds);
    } catch (error) {
      console.error("Error in redirection");
    }
  }

}